import { Link } from "react-router-dom";
import PetBook from "../../assets/icons/PetBook";
import { ProfileComponent } from "../../components/common/ProfileComponent";
import { IUser } from "../../interfaces/user";
import {
  CenterColumns,
  ComponentGroupButton,
  TdEmail,
  TdPhone,
} from "./index.style";
import ChatConversation from "../../assets/icons/ChatConversation";
import { IPets } from "../../interfaces/pets";
import { ColumnsType } from "antd/lib/table";

export default function conversDataToRowsDatabaseUserPage(
  dataUsers: IUser[],
  handleShowModalPets: (pets: IPets[]) => void
) {
  return dataUsers.map((item) => [
    ProfileComponent({
      name: `${item.firstName} ${item.lastName}`,
      avatar: item.imageUrl || "",
      lineId: item.petsName && `สัตว์เลี้ยง: ${item.petsName}`,
      style: { minWidth: "280px" },
      styleLineId: { maxWidth: "280px" },
    }),
    <TdPhone>{item.displayName}</TdPhone>,
    <TdPhone>{item.phone}</TdPhone>,
    <TdEmail>{item.email}</TdEmail>,
    <ComponentGroupButton>
      <PetBook
        style={{ cursor: "pointer", marginRight: "0.5rem" }}
        onClick={() => handleShowModalPets(item.pets || [])}
      />
      <Link
        to={{
          pathname: `/adminChat/${item.uid}`,
          state: {
            item,
          },
        }}
        style={{ textDecoration: "none" }}
      >
        <ChatConversation
          style={{ cursor: "pointer", marginRight: "0.5rem" }}
          onClick={() => handleShowModalPets(item.pets || [])}
        />
      </Link>
    </ComponentGroupButton>,
  ]);
}

export const columns = (handleShowModalPets: (pets: IPets[]) => void) => {
  return [
    {
      title: <CenterColumns>ชื่อลูกค้า</CenterColumns>,
      dataIndex: "name",
      key: "name",
      render: (_: string, record: IUser) =>
        ProfileComponent({
          name: `${record.firstName} ${record.lastName}`,
          avatar: record.imageUrl || "",
          lineId: record.petsName && `สัตว์เลี้ยง: ${record.petsName}`,
        }),
      width: "300px",
    },
    {
      title: <CenterColumns>ชื่อไลน์</CenterColumns>,
      dataIndex: "displayName",
      key: "displayName",
    },
    {
      title: <CenterColumns>เบอร์โทรศัพท์</CenterColumns>,
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: <CenterColumns>อีเมลที่ใช้งาน</CenterColumns>,
      dataIndex: "email",
      key: "email",
      ellipsis: true,
    },
    {
      title: <CenterColumns>อื่นๆ</CenterColumns>,
      dataIndex: "other",
      key: "other",
      render: (_: string, record: IUser) => (
        <ComponentGroupButton>
          <PetBook
            style={{ cursor: "pointer", marginRight: "0.5rem" }}
            onClick={() => handleShowModalPets(record.pets || [])}
          />
          <Link
            to={{
              pathname: `/adminChat/${record.uid}`,
              state: {
                record,
              },
            }}
            style={{ textDecoration: "none" }}
          >
            <ChatConversation
              style={{ cursor: "pointer", marginRight: "0.5rem" }}
              onClick={() => handleShowModalPets(record.pets || [])}
            />
          </Link>
        </ComponentGroupButton>
      ),
    },
  ] as ColumnsType<IUser>;
};
